export const TOAST_DEFAULT_DURATION = 5000;
export const TOAST_EXIT_DURATION = 200;
export const TOAST_MAX_VISIBLE = 3;
export const TOAST_STACK_GAP = 16;
export const TOAST_STACK_SCALE_STEP = 0.05;
